<template>
  <div>
    <!--面包屑-->
    <breadcrumb-link :title="getTitle"></breadcrumb-link>
    <!--内容区域-->
    <div>
      <el-form
        class="box-detail"
        label-width="130px"
        ref="detail"
        :inline="true"
        :model="detail"
        :disabled="getDisabled"
      >
        <div class="edit-title">基础信息</div>
        <el-form-item
          label="Pipeline名称"
          label-width="130px"
          prop="name"
          :rules="[
            {required: true, message: '必填，不超过50个字符'},
          ]"
        >
          <el-col :span="24">
            <el-input
              class="main-input"
              placeholder="必填，不超过50个字符"
              maxlength="50"
              show-word-limit
              v-model="detail.name"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item
          label="实例主机地址"
          label-width="130px"
          prop="executorHost"
          :rules="[
            {required: true, message: '必填'},
          ]"
        >
          <el-col :span="24">
            <el-input
              class="main-input"
              placeholder="请输入运行实例主机地址"
              v-model="detail.executorHost"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-button
          type="primary"
          @click="submitForm('detail',pushForm)" v-if="type!='details'">保存
        </el-button>
      </el-form>
      <el-form
        class="box-detail"
        label-width="130px"
        ref="route"
        :inline="true"
        :model="route"
        :disabled="getDisabled">
        <div class="edit-title">Route配置</div>
        <div class="route-list">
          <div class="route-item" v-for="(item, index) in route.pipelineRouteVOList" :key="index">
            <el-form-item
              label="Route名称"
              :prop="'pipelineRouteVOList['+ index + '].name'"
              :rules="[
                {required: true, message: '必填',trigger: 'blur'},
              ]"
            >
              <el-input
                class="route-input"
                placeholder="请输入Route名称"
                maxlength="50"
                show-word-limit
                v-model="item.name"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="Source选择"
              :prop="'pipelineRouteVOList['+ index + '].pipelineSourceVO.sourceId'"
              :rules="[
                {required: true, message: '请选择Source',}
              ]"
            >
              <el-select
                v-model="item.pipelineSourceVO"
                filterable
                :placeholder="item.pipelineSourceVO.name"
                style="width: 240px"
                @focus="getTargetList('sourceList', item.id)"
                value-key="sourceId"
              >
                <el-option
                  v-for="(itm, idx) in sourceList"
                  :key="idx"
                  :label="itm.name"
                  :value="itm"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="Sink选择"
              :prop="'pipelineRouteVOList['+ index + '].pipelineSinkVO.sinkId'"
              :rules="[
                {required: true, message: '请选择Sink'}
              ]"
            >
              <el-select
                v-model="item.pipelineSinkVO"
                filterable
                :placeholder="item.pipelineSinkVO.name"
                @focus="getTargetList('sinkList', item.id)"
                style="width: 240px;"
                value-key="sinkId"
              >
                <el-option
                  v-for="(itm, idx) in sinkList"
                  :key="idx"
                  :label="itm.name"
                  :value="itm">
                </el-option>
              </el-select>
            </el-form-item>
            <div class="route-button"  v-if="type != 'details'">
              <el-button type="primary" @click="submitForm('route', addRoute, index)">保存route</el-button>
              <el-button type="primary" @click="detRoute(type, index, item.id)">删除route</el-button>
            </div>
          </div>
          <div class="add-button" v-if="type != 'details'">
            <el-button type="primary" @click="addRouteHtml()">新增route</el-button>
          </div>
        </div>

        <div v-if="initType== 'details'">
          <history-record
            :historyTitle="historyTitle"
            :historyList="historyList"/>
        </div>
      </el-form>
      <div style="padding-left: 130px">
        <el-button type="info" plain @click="goBack">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import BreadcrumbLink from '../../../components/breadcrumbLink';
  import util from '@/utils/util';
  import HistoryRecord from '../../../components/common/historyRecord';
  import {
    addPipeline,
    editPipeline,
    getPipelineInfo,
    getSourceUnUsedList,
    getSinkUnUsedList,
    addRoute,
    editRoute,
    deleteRoute
  } from '@/apis/pipelineService/pipelineConfig';

  export default {
    components: {
      HistoryRecord,
      BreadcrumbLink,
    },
    data() {
      return {
        type: '', // 跳转页面获取标题
        initType:'',
        detail: {
          name: '',  // pipeline名称
          executorHost: null,
          pipelineRouteVOList: [{
            name: '',
            pipelineSinkVO: { id: null },
            pipelineSourceVO: { id: null }
          }],
        },
        route: {
          name: '',
          pipelineRouteVOList: [{
            name: '',
            pipelineSinkVO: { id: null },
            pipelineSourceVO: { id: null }
          }],
        },
        setOptions: {
          name: '',
          executorHost: null,
          pipelineRouteVOList: [{
            name: '',
            pipelineSinkVO: { id: null },
            pipelineSourceVO: { id: null }
          }],
        },
        sourceList:[],
        sinkList:[],
        newSourceList: [],
        newSinkList: [],
        historyTitle: '记录信息', // 记录信息标题
        historyList: [], // 记录信息信息内容
        id: this.$route.query.id,
      };
    },
    computed: {
      getDisabled() {
        return {'add': false,'edit': false,'details': true}[this.type];
      },
      getTitle() {
        return {'add': '新增Pipeline配置','edit': '修改Pipeline配置','details': 'Pipeline配置详情'}[this.type];
      },
    },
    mounted() {
      this.type = this.$route.query.type;
      this.initType = this.$route.query.type;
      if (this.type != 'add') {
        this.getDetails()
      }else {
      //   this.getTargetList('sourceList')
      //  this.getTargetList('sinkList')
      }
    },
    methods: {
      // 添加路由
      async addRoute(index) {
        let params = {
        }
        if(!this.id) {
          this.$message.warning('请先保存Pipeline名称')
          return false
        }
        params = Object.assign(params, this.route.pipelineRouteVOList[index], {pipelineId:this.id})
        let data = params.id ? await editRoute(params): await addRoute(params);
        if(data.code == 0) {
          this.$message.success(data.message);
          this.getDetails()
        }else {
          let text = params.id ? '更新': '添加';
          this.$message.error(text + '路由失败，' + data.message)
        }
      },
      // 删除路由
      async detRoute(type, index, id) {
        if(id) {
          let params = {
            id
          }
          let data = await deleteRoute(params)
          if(data.code == 0) {
            this.$message.success(data.message);
            this.route.pipelineRouteVOList.splice(index,1)
          }else {
            this.$message.error(data.message);
          }
        } else {
          this.route.pipelineRouteVOList.splice(index,1)
        }
      },

      // 获取source/sink列表
      async getTargetList(target, id) {
        let params = {
          routeId: id
        };
        try {
          const data = target == 'sourceList' ? await getSourceUnUsedList(params) : await getSinkUnUsedList(params)
          if (data.code == 0 && data.data) {
            this[target] = data.data
          }else {
            this.$message.error(data.message)
          }
        } catch (error) {
          console.log(error)
        }
      },
      // 详情
      async getDetails() {
        let params = {
          id: this.id,
        };
        try {
          const data = await getPipelineInfo(params);
          if (data.code == 0 && data.data) {
            if(this.type != 'add') {
              for(let i = 0 ; i<data.data.pipelineRouteVOList.length ; i++) {
                let item = data.data.pipelineRouteVOList[i]
                if(item&&item.pipelineSinkVO) {
                  let type = item.pipelineSinkVO.sinkType
                  if(!item.pipelineSinkVO.sinkId) item.pipelineSinkVO.sinkId =  item.pipelineSinkVO.id + '_' + (type == 'File' ? 0 : 1)
                  this.sinkList.push(item.pipelineSinkVO)
                }
                if(item&&item.pipelineSourceVO) {
                  let type = item.pipelineSourceVO.sourceType
                  if(!item.pipelineSourceVO.sourceId) item.pipelineSourceVO.sourceId = item.pipelineSourceVO.id + '_' + (type == 'Kafka' ? 0 : (type == 'Canal' ? 1 : 2)) 
                  this.sourceList.push(item.pipelineSourceVO)
                }
              }
            }
            this.detail = data.data;
            this.route = data.data
            this.historyList = [
            {
              label: '创建人：',
              value: data.data.creatorName,
            }, {
              label: '创建时间：',
              value: data.data.createTime.replace(/T/g,' '),
            },
            {
              label: '最后修改人：',
              value: data.data.updatorName,
            }, {
              label: '修改时间：',
              value: data.data.updateTime.replace(/T/g,' '),
            }];
            console.log(this.historyList)
          }else {
            this.$message.error(data.message)
          }
        } catch (error) {
          console.log(error)
        }
      },
      // 提交表单
      submitForm(formName, callback, index) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            index != undefined ? callback(index) : callback()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 提交
      async pushForm() {
        let params = {
          ...this.detail
        };
        if (this.type == 'add') {
          delete params.id;
        }
        try {
          const data = this.type == 'add' ? await addPipeline(params) : await editPipeline(params)
          if (data.code == 0) {
            if (this.type == 'add') {
              let route = this.$route
              this.type = 'edit'
              this.detail.id = data.data.id
              this.id = data.data.id
              this.$router.replace({path: route.path + '?type=edit&id=' + data.data.id})
            }
            this.$message.success(data.message);
          } else {
            this.$message.error(data.message)
          }
        } catch (error) {
          this.message.error(error)
        }
      },
      // 添加路由dom
      addRouteHtml() {
        let length = this.route.pipelineRouteVOList.length
        if(length == 0 || this.route.pipelineRouteVOList[length -1].id) {
          this.route.pipelineRouteVOList.push({
            name:'',
            pipelineSinkVO: { id: null },
            pipelineSourceVO: { id: null }
          })
        }else {
          this.$message.warning('请先保存当前路由')
        }
      },
      // 返回上一层
      goBack() {
        this.$router.go(-1);
      },
    }
  };
</script>

<style scoped lang="scss">
  .box-detail {
    width: 850px;
    .main-input {
      width: 500px;
    }
    .route-list {
      // background:#f6f6f6;
      margin-bottom: 20px;
      padding-bottom: 20px;
      .route-item {
        // margin-bottom: 20px;
        background:#f6f6f6;
        padding: 20px 0;
        .route-button {
          display: flex;
          justify-content: center;
          .el-icon-delete {
            font-size:20px;
            margin-top: 9px;
            margin-left: 20px;
            cursor: pointer;
          }
        }
        .route-input {
          width:400px
        }
      }
      .add-button {
        margin: 20px auto 0;
        width: 300px;
        display: flex;
        justify-content: space-around;
      }
    }
  }
</style>
